export const GATEWAY_URL = 'https://gatewaydev.cella.co.za';
export const APP_NAME = 'Cella InTransit';
export const VERSION_NUMBER = '1.0.0';

export type TenantCodes = 'LLINER' | 'LIEBEN';
